import { useState } from 'react';
import { DropDownSelector, ButtonBasic, TextareaDynamicPlaceholder } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from '../ModalComponent/ModalComponent';
import './ModalMassEditing.scss'

const ModalMassEditing = ({
    setIsModal,
    createMassTemplate,
    groupList,
    createTemplate,
    selectedGroupId
}) => {

    const [value, setValue] = useState('')
    const options_prop = groupList.map(el => ({ label: el?.group_name, value: el?.id }))
    const current_group = options_prop.filter(({ value }) => value == selectedGroupId)
    const [selectedGroupFilter, setSelectedGroupFilter] = useState(current_group ? current_group[0] : [])


    const onSaveHandler = () => {

        if (value?.length > 0) {
            if (!selectedGroupFilter?.value) {
                const body = value?.split(/\n\n/).map((el) => el)
                createTemplate(body)
            } else {
                createMassTemplate(value, selectedGroupFilter?.value)
            }
        }
        setIsModal(false)
    }

    return (
        <ModalComponent
            title='Массовое добавление'
            onClose={(e) => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '800px'
            }}
            childHeader={
                <DropDownSelector
                    options_prop={options_prop}
                    state={selectedGroupFilter}
                    setState={setSelectedGroupFilter}
                    placeholder='Выберите группу'
                />
            }
            child={
                <div className='modal-mass-editing'>
                    <TextareaDynamicPlaceholder
                        width='100%'
                        changeValue={value}
                        placeholder="Введите текст"
                        onChange={setValue}
                        tooltip={'Разделение шаблонов ответов происходит при нажатии дважды на enter'}
                    />

                    <ButtonBasic
                        green
                        size='56px'
                        text='Сохранить'
                        width='162px'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                        onClick={onSaveHandler}
                    />
                </div>
            }
        />
    )
}

export { ModalMassEditing }